import { useEffect, useRef, useState } from 'react';
import { formatElapsed } from '#features/date';


/**
 * Сколько идёт разговор. Отсчёт ведётся от входа в голос, а не от начала сессии: человеку важно,
 * сколько говорит он, а не сколько тянется встреча.
 *
 * Обновляется раз в секунду и печатается tabular-nums на стороне вызова, иначе ширина виджета
 * прыгает на каждой смене цифры.
 */
export const useVoiceDuration = (active: boolean) => {
  const startedAtRef = useRef<number | null>(null);
  const [value, setValue] = useState('0:00');

  useEffect(() => {
    if (!active) {
      startedAtRef.current = null;
      setValue('0:00');
      return undefined;
    }

    startedAtRef.current ??= Date.now();
    const tick = () => {
      const startedAt = startedAtRef.current;
      if (startedAt) {
        setValue(formatElapsed(Math.max(0, Math.floor((Date.now() - startedAt) / 1000))));
      }
    };

    tick();
    const timer = window.setInterval(tick, 1000);
    return () => window.clearInterval(timer);
  }, [active]);

  return value;
};
